import { useTrips } from 'tripPlanner/hooks/api/trip'

function useHasClassicTripPlannerTrips(enabled = true) {
  const {
    data: classicTrips = [],
    isError: hasClassicTripLookupError,
    isFetching,
    isFetched,
  } = useTrips({
    enabled,
  })

  return {
    hasClassicTripPlannerTrips: classicTrips.length > 0,
    hasClassicTripLookupError,
    isLoadingClassicTripPlannerTrips: isFetching && !isFetched,
  }
}

export default useHasClassicTripPlannerTrips
